import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTextDivider, LazyCreateTestModal, LazyDuplicateTestModal, LazyEditTestNameModal, LazyEndTestModal, LazyStartTestModal, LazyInfoAccordion, LazyLinkAccordion, LazyPayoutAccordion, LazyAddressHistoryItem, LazyActivateStoreModal, LazyAddProtectionModal, LazyBasicQuestionModal, LazyCreateAdminUser, LazyCreateApiToken, LazyCreateCategory, LazyCreateMacro, LazyCreateStoreModal, LazyCreateWebhook, LazyDeactivateStoreModal, LazyDeleteApiTokenModal, LazyDeleteCategoryModal, LazyDeleteMacro, LazyDeleteSopModal, LazyDeleteWebhookModal, LazyMoveMacroModal, LazyMoveStoreToDevelopmentModal, LazyMoveStoreToOnboardingModal, LazyNewApiTokenModal, LazyReInstallStore, LazyRemoveProtection, LazyRenameCategory, LazyResetOverrideMacroModal, LazyUpdateToActiveSopModal, LazyUpdateToInactiveSopModal, LazyWebhookRequestResponse, LazyContactInformation, LazyCreateBigcommerceStore, LazyCreateDefaultStore, LazyCreateShopifyStore, LazyMerchantInformation, LazyRangeRule, LazyRangeRuleSet, LazySignIn, LazyWelcomeBack, LazyAvatarGroup, LazyPlatformAvatar, LazyUserAvatar, LazyMetadataBadge, LazyNoFraudBadge, LazyProtectionStatusBadge, LazyRiskLevelBadge, LazyStatusBadge, LazyBasicCard, LazyChatAttachment, LazyChatImageUploader, LazyMessageBox, LazyAlsoViewing, LazyClaimFeed, LazyClaimItemCard, LazyClaimMetricRow, LazyClaimStateBadge, LazyClaimsInfoButton, LazyClaimsTable, LazyFulfillmentInfo, LazyIssueGallery, LazyIssueGalleryCard, LazyItemIssue, LazyPaymentSection, LazyReturnCard, LazyReturnsFeed, LazySetClaimType, LazyShippingClaim, LazyShippingClaimMetric, LazyShippingClaimPhotos, LazySingleClaim, LazyCustomerAddresses, LazyFulfillmentTable, LazySopTab, LazyTrackingInfo, LazyAddPaymentMethod, LazyAddPayoutMethod, LazyApproveClaim, LazyClaimsInfoModal, LazyCloseClaim, LazyDenyClaim, LazyDismissClaim, LazyEditShippingAddress, LazyMoveToApprovedModal, LazyMoveToClosedModal, LazyMoveToDeniedModal, LazyOnHoldClaim, LazyPendingClaim, LazyShippingAddressHistoryModal, LazyToDoClaim, LazyApproveClaimCustom, LazyCreditStoreQuestion, LazyFlatRateType, LazyFullFlatRate, LazyFullRefund, LazyFullReship, LazyFullStoreCredit, LazyRefundItem, LazyRefundShipping, LazyReshipRefundResolutionDetails, LazyResolutionBreakdown, LazyDesktopView, LazyLoaderBar, LazyMobileView, LazyCustomerMetricCard, LazyCustomerMetricRow, LazyCustomerMetrics, LazyCustomerName, LazyCustomerProtectedOrderHistoryTable, LazyCustomerTable, LazyCustomerTags, LazyAnalyticsTile, LazyClaimsByTypeTile, LazyTopProductsWithShippingClaimsTile, LazyABTestDataDisplay, LazyDataDisplay, LazyDataMetric, LazyDateFilter, LazyProductDisplay, LazyProductResolution, LazySettingsGeneralTagging, LazyStoreCreditOptions, LazyToggleDisplay, LazyMethodSettings, LazyAddFilterButton, LazyDesktopFilterButton, LazyFilterButton, LazyFilterOptionRow, LazyFilters, LazyMobileFilterButton, LazyTableFilter, LazyTablePagination, LazySortButton, LazyGlobalMacroCard, LazyGlobalMacroCategoryList, LazyDashboardIndex, LazyDashboardIndividual, LazyMacroCard, LazyMacroCategoryButtonMenu, LazyMacroCategoryList, LazyMacroDetails, LazyAddMacroModal, LazyMessagingEvent, LazyMessagingEventDivider, LazyMessagingFeed, LazyAddTagModalTest, LazyAddTagModal, LazyConfirmationModal, LazyCreateBrandModal, LazyCreateDeploymentModal, LazyCreateReturnModal, LazyCreateReviewModal, LazyDeleteStoreCreditModal, LazyEditBrandModal, LazyNavAccordion, LazyNavDivider, LazyNavGroupTitle, LazyNavItem, LazyNavItems, LazySideNav, LazyTabbedNav, LazyOrdersTable, LazyProtectedOrderItemCard, LazyProtectedOrderMetricRow, LazyReimbursementModal, LazyStatisticTile, LazySearchInput, LazySearchModal, LazySearchProductModal, LazyCopyText, LazyCustomerAddress, LazyEditButton, LazyApiTokenCard, LazyApiTokenCardSkeleton, LazyEmptyState, LazyDropArea, LazyMediaUploader, LazyPageIcon, LazySharedFooter, LazyBasicModal, LazySimplePopover, LazySelectionGroup, LazyErrorGroup, LazyStoreDisplay, LazyStoreSelect, LazyStoreSelectButton, LazyTeamMembersInfoButton, LazyUserRoleBadge, LazyCreateTeamMember, LazyTeamMembersEntitlementsCard, LazyTeamMembersInfoModal, LazyThemeSwitch, LazyNotificationToast, LazyToastController, LazyWebhookCard, LazyWebhookCardSkeleton, LazyWebhookTopicGroup, LazyPulseEmptyState, LazyPulseLoadingSpinner, LazyPulseMediaCarousel, LazyPulseTooltip, LazyPulseBanner, LazyPulseChatAttachment, LazyPulseClaimFeed, LazyPulseCustomerAddress, LazyPulseCustomerAddresses, LazyPulseDataMetric, LazyPulseFeedback, LazyPulseFulfillmentInfo, LazyPulseInfoBanner, LazyPulseMessagingEvent, LazyPulseMessagingEventDivider, LazyPulseMessagingFeed, LazyPulseModal, LazyPulsePlatformAvatar, LazyPulseProductDisplay, LazyPulseReshipRefundResolutionDetails, LazyPulseShippingClaimMetric, LazyPulseStatusBadge, LazyPulseSuccessBanner, LazyPulseTagList, LazyPulseToggleDisplay, LazyPulseTrackingInfo, LazyPulseUserAvatar, LazyPulseWarningBanner, LazyPulseTable, LazyPulseTableGridSkeleton, LazyPulseTableSkeleton, LazyPulseAddBook, LazyPulseApiLogo, LazyPulseArmraLogo, LazyPulseArrowsRightLeft, LazyPulseBigCommerce, LazyPulseCheckCircle, LazyPulseCircleLogo, LazyPulseClaimInfoSubscribedRightArrows, LazyPulseClaimTodoApprovedDeniedSolidArrow, LazyPulseClaimTodoClosedSolidArrow, LazyPulseClaimTodoDashed, LazyPulseClaimTodoDashedArrow, LazyPulseClaimTodoOnholdDashed, LazyPulseClaimTodoOnholdDashedArrow, LazyPulseClaimTodoPendingDashed, LazyPulseClaimTodoPendingDashedArrow, LazyPulseClaimTodoSolidLine, LazyPulseDatePicker, LazyPulseEarthGlobeTimezone, LazyPulseFolderCheck, LazyPulseFollowUp, LazyPulseIconApprove, LazyPulseIconArmra, LazyPulseIconAvatar, LazyPulseIconBuilding, LazyPulseIconCheck, LazyPulseIconClose, LazyPulseIconCreditCard, LazyPulseIconCustom, LazyPulseIconDanger, LazyPulseIconDollar, LazyPulseIconEdit, LazyPulseIconGoogle, LazyPulseIconInfo, LazyPulseIconLock, LazyPulseIconLogo, LazyPulseIconRefund, LazyPulseIconSend, LazyPulseIconShipment, LazyPulseIconShopify, LazyPulseIconWarning, LazyPulseImageCancel, LazyPulseLineAlign, LazyPulseLineAlphabet, LazyPulseLineAngleDoubleLeft, LazyPulseLineAngleDoubleRight, LazyPulseLineAngleDown, LazyPulseLineAngleLeft, LazyPulseLineAngleRight, LazyPulseLineAngleUp, LazyPulseLineAppleAlt, LazyPulseLineArchive, LazyPulseLineArrow, LazyPulseLineArrowDownRight, LazyPulseLineArrowLeft, LazyPulseLineArrowRight, LazyPulseLineBars, LazyPulseLineBold, LazyPulseLineBolt, LazyPulseLineBookMedical, LazyPulseLineBox, LazyPulseLineBuilding, LazyPulseLineCameraPlus, LazyPulseLineCameraQuestion, LazyPulseLineChart, LazyPulseLineChatBubbleUser, LazyPulseLineCheckCircle, LazyPulseLineClipboardAlt, LazyPulseLineCodeBranch, LazyPulseLineCoins, LazyPulseLineCommentAlt, LazyPulseLineCommentAltBlock, LazyPulseLineCommentDots, LazyPulseLineCommentMessage, LazyPulseLineCommentQuestion, LazyPulseLineComparison, LazyPulseLineCopy, LazyPulseLineCornerUpLeftAlt, LazyPulseLineCornerUpRightAlt, LazyPulseLineCreditCard, LazyPulseLineDashboard, LazyPulseLineDownloadAlt, LazyPulseLineDraggabledots, LazyPulseLineEllipsisH, LazyPulseLineExclamationCircle, LazyPulseLineExclamationOctagon, LazyPulseLineExport, LazyPulseLineExternalLinkAlt, LazyPulseLineEye, LazyPulseLineEyeSlash, LazyPulseLineFileCopyAlt, LazyPulseLineFileLandscape, LazyPulseLineFilter, LazyPulseLineFire, LazyPulseLineFolder, LazyPulseLineFolderOpen, LazyPulseLineFont, LazyPulseLineGithubAlt, LazyPulseLineGlobe, LazyPulseLineImage, LazyPulseLineImageBroken, LazyPulseLineImport, LazyPulseLineInfoCircle, LazyPulseLineItalic, LazyPulseLineLeftIndent, LazyPulseLineLinkAlt, LazyPulseLineListOl, LazyPulseLineListUl, LazyPulseLineLock, LazyPulseLineMessage, LazyPulseLineMinusCircle, LazyPulseLineMoney, LazyPulseLineMoneyWithdraw, LazyPulseLineMoon, LazyPulseLinePalette, LazyPulseLinePaperclip, LazyPulseLinePen, LazyPulseLinePhone, LazyPulseLinePlus, LazyPulseLinePlusCircle, LazyPulseLinePlusSquare, LazyPulseLineRefresh, LazyPulseLineRightIndentAlt, LazyPulseLineRocket, LazyPulseLineSearch, LazyPulseLineSetting, LazyPulseLineShield, LazyPulseLineSlack, LazyPulseLineSort, LazyPulseLineStar, LazyPulseLineSun, LazyPulseLineSwatchbook, LazyPulseLineSync, LazyPulseLineTable, LazyPulseLineTag, LazyPulseLineTimes, LazyPulseLineTimesCircle, LazyPulseLineToggleOff, LazyPulseLineToggleOn, LazyPulseLineTransaction, LazyPulseLineTrashAlt, LazyPulseLineUnderline, LazyPulseLineUsdCircle, LazyPulseLineUsersAlt, LazyPulseLoopreturns, LazyPulseMagentoLogo, LazyPulseNoResponse, LazyPulseOutsideOp, LazyPulsePackage, LazyPulsePackageArrived, LazyPulsePlayCircle, LazyPulsePlusCircle, LazyPulseQueueList, LazyPulseRefreshResentMail, LazyPulseShieldCheck, LazyPulseShipstation, LazyPulseShopifyAvatar, LazyPulseShopifyBag, LazyPulseSolidStar, LazyPulseTableDeleteColumn, LazyPulseTableDeleteRow, LazyPulseTableInsertColumnAfter, LazyPulseTableInsertColumnBefore, LazyPulseTableInsertRowAbove, LazyPulseTableInsertRowAfter, LazyPulseTableOptions, LazyPulseTableSettings, LazyPulseTipaltiLogo, LazyPulseXCircle, LazyPulseXMark, LazyPulseAccordionCard, LazyPulseBasicCard, LazyPulsePageIcon, LazyPulseShippingClaim, LazyPulseSingleClaim, LazyPulseTabbedNav, LazyPulseButton, LazyPulseChatImageUploader, LazyPulseColorInput, LazyPulseDateRangePicker, LazyPulseDropdown, LazyPulseIconButton, LazyPulseInput, LazyPulseLabelPopper, LazyPulseMessageBox, LazyPulseMultiDropdown, LazyPulseMultiSelectDropdown, LazyPulseOptionsMenu, LazyPulsePasswordInput, LazyPulseRadioButton, LazyPulseRadioQuestion, LazyPulseRteFileComponent, LazyPulseRteVideoComponent, LazyPulseRichTextEditor, LazyPulseSelect, LazyPulseTagSelect, LazyPulseTextArea, LazyPulseToggle, LazyPulseValidationGroup } from '#components'
const lazyGlobalComponents = [
  ["TextDivider", LazyTextDivider],
["CreateTestModal", LazyCreateTestModal],
["DuplicateTestModal", LazyDuplicateTestModal],
["EditTestNameModal", LazyEditTestNameModal],
["EndTestModal", LazyEndTestModal],
["StartTestModal", LazyStartTestModal],
["InfoAccordion", LazyInfoAccordion],
["LinkAccordion", LazyLinkAccordion],
["PayoutAccordion", LazyPayoutAccordion],
["AddressHistoryItem", LazyAddressHistoryItem],
["ActivateStoreModal", LazyActivateStoreModal],
["AddProtectionModal", LazyAddProtectionModal],
["BasicQuestionModal", LazyBasicQuestionModal],
["CreateAdminUser", LazyCreateAdminUser],
["CreateApiToken", LazyCreateApiToken],
["CreateCategory", LazyCreateCategory],
["CreateMacro", LazyCreateMacro],
["CreateStoreModal", LazyCreateStoreModal],
["CreateWebhook", LazyCreateWebhook],
["DeactivateStoreModal", LazyDeactivateStoreModal],
["DeleteApiTokenModal", LazyDeleteApiTokenModal],
["DeleteCategoryModal", LazyDeleteCategoryModal],
["DeleteMacro", LazyDeleteMacro],
["DeleteSopModal", LazyDeleteSopModal],
["DeleteWebhookModal", LazyDeleteWebhookModal],
["MoveMacroModal", LazyMoveMacroModal],
["MoveStoreToDevelopmentModal", LazyMoveStoreToDevelopmentModal],
["MoveStoreToOnboardingModal", LazyMoveStoreToOnboardingModal],
["NewApiTokenModal", LazyNewApiTokenModal],
["ReInstallStore", LazyReInstallStore],
["RemoveProtection", LazyRemoveProtection],
["RenameCategory", LazyRenameCategory],
["ResetOverrideMacroModal", LazyResetOverrideMacroModal],
["UpdateToActiveSopModal", LazyUpdateToActiveSopModal],
["UpdateToInactiveSopModal", LazyUpdateToInactiveSopModal],
["WebhookRequestResponse", LazyWebhookRequestResponse],
["ContactInformation", LazyContactInformation],
["CreateBigcommerceStore", LazyCreateBigcommerceStore],
["CreateDefaultStore", LazyCreateDefaultStore],
["CreateShopifyStore", LazyCreateShopifyStore],
["MerchantInformation", LazyMerchantInformation],
["RangeRule", LazyRangeRule],
["RangeRuleSet", LazyRangeRuleSet],
["SignIn", LazySignIn],
["WelcomeBack", LazyWelcomeBack],
["AvatarGroup", LazyAvatarGroup],
["PlatformAvatar", LazyPlatformAvatar],
["UserAvatar", LazyUserAvatar],
["MetadataBadge", LazyMetadataBadge],
["NoFraudBadge", LazyNoFraudBadge],
["ProtectionStatusBadge", LazyProtectionStatusBadge],
["RiskLevelBadge", LazyRiskLevelBadge],
["StatusBadge", LazyStatusBadge],
["BasicCard", LazyBasicCard],
["ChatAttachment", LazyChatAttachment],
["ChatImageUploader", LazyChatImageUploader],
["MessageBox", LazyMessageBox],
["AlsoViewing", LazyAlsoViewing],
["ClaimFeed", LazyClaimFeed],
["ClaimItemCard", LazyClaimItemCard],
["ClaimMetricRow", LazyClaimMetricRow],
["ClaimStateBadge", LazyClaimStateBadge],
["ClaimsInfoButton", LazyClaimsInfoButton],
["ClaimsTable", LazyClaimsTable],
["FulfillmentInfo", LazyFulfillmentInfo],
["IssueGallery", LazyIssueGallery],
["IssueGalleryCard", LazyIssueGalleryCard],
["ItemIssue", LazyItemIssue],
["PaymentSection", LazyPaymentSection],
["ReturnCard", LazyReturnCard],
["ReturnsFeed", LazyReturnsFeed],
["SetClaimType", LazySetClaimType],
["ShippingClaim", LazyShippingClaim],
["ShippingClaimMetric", LazyShippingClaimMetric],
["ShippingClaimPhotos", LazyShippingClaimPhotos],
["SingleClaim", LazySingleClaim],
["CustomerAddresses", LazyCustomerAddresses],
["FulfillmentTable", LazyFulfillmentTable],
["SopTab", LazySopTab],
["TrackingInfo", LazyTrackingInfo],
["AddPaymentMethod", LazyAddPaymentMethod],
["AddPayoutMethod", LazyAddPayoutMethod],
["ApproveClaim", LazyApproveClaim],
["ClaimsInfoModal", LazyClaimsInfoModal],
["CloseClaim", LazyCloseClaim],
["DenyClaim", LazyDenyClaim],
["DismissClaim", LazyDismissClaim],
["EditShippingAddress", LazyEditShippingAddress],
["MoveToApprovedModal", LazyMoveToApprovedModal],
["MoveToClosedModal", LazyMoveToClosedModal],
["MoveToDeniedModal", LazyMoveToDeniedModal],
["OnHoldClaim", LazyOnHoldClaim],
["PendingClaim", LazyPendingClaim],
["ShippingAddressHistoryModal", LazyShippingAddressHistoryModal],
["ToDoClaim", LazyToDoClaim],
["ApproveClaimCustom", LazyApproveClaimCustom],
["CreditStoreQuestion", LazyCreditStoreQuestion],
["FlatRateType", LazyFlatRateType],
["FullFlatRate", LazyFullFlatRate],
["FullRefund", LazyFullRefund],
["FullReship", LazyFullReship],
["FullStoreCredit", LazyFullStoreCredit],
["RefundItem", LazyRefundItem],
["RefundShipping", LazyRefundShipping],
["ReshipRefundResolutionDetails", LazyReshipRefundResolutionDetails],
["ResolutionBreakdown", LazyResolutionBreakdown],
["DesktopView", LazyDesktopView],
["LoaderBar", LazyLoaderBar],
["MobileView", LazyMobileView],
["CustomerMetricCard", LazyCustomerMetricCard],
["CustomerMetricRow", LazyCustomerMetricRow],
["CustomerMetrics", LazyCustomerMetrics],
["CustomerName", LazyCustomerName],
["CustomerProtectedOrderHistoryTable", LazyCustomerProtectedOrderHistoryTable],
["CustomerTable", LazyCustomerTable],
["CustomerTags", LazyCustomerTags],
["AnalyticsTile", LazyAnalyticsTile],
["ClaimsByTypeTile", LazyClaimsByTypeTile],
["TopProductsWithShippingClaimsTile", LazyTopProductsWithShippingClaimsTile],
["ABTestDataDisplay", LazyABTestDataDisplay],
["DataDisplay", LazyDataDisplay],
["DataMetric", LazyDataMetric],
["DateFilter", LazyDateFilter],
["ProductDisplay", LazyProductDisplay],
["ProductResolution", LazyProductResolution],
["SettingsGeneralTagging", LazySettingsGeneralTagging],
["StoreCreditOptions", LazyStoreCreditOptions],
["ToggleDisplay", LazyToggleDisplay],
["MethodSettings", LazyMethodSettings],
["AddFilterButton", LazyAddFilterButton],
["DesktopFilterButton", LazyDesktopFilterButton],
["FilterButton", LazyFilterButton],
["FilterOptionRow", LazyFilterOptionRow],
["Filters", LazyFilters],
["MobileFilterButton", LazyMobileFilterButton],
["TableFilter", LazyTableFilter],
["TablePagination", LazyTablePagination],
["SortButton", LazySortButton],
["GlobalMacroCard", LazyGlobalMacroCard],
["GlobalMacroCategoryList", LazyGlobalMacroCategoryList],
["DashboardIndex", LazyDashboardIndex],
["DashboardIndividual", LazyDashboardIndividual],
["MacroCard", LazyMacroCard],
["MacroCategoryButtonMenu", LazyMacroCategoryButtonMenu],
["MacroCategoryList", LazyMacroCategoryList],
["MacroDetails", LazyMacroDetails],
["AddMacroModal", LazyAddMacroModal],
["MessagingEvent", LazyMessagingEvent],
["MessagingEventDivider", LazyMessagingEventDivider],
["MessagingFeed", LazyMessagingFeed],
["AddTagModalTest", LazyAddTagModalTest],
["AddTagModal", LazyAddTagModal],
["ConfirmationModal", LazyConfirmationModal],
["CreateBrandModal", LazyCreateBrandModal],
["CreateDeploymentModal", LazyCreateDeploymentModal],
["CreateReturnModal", LazyCreateReturnModal],
["CreateReviewModal", LazyCreateReviewModal],
["DeleteStoreCreditModal", LazyDeleteStoreCreditModal],
["EditBrandModal", LazyEditBrandModal],
["NavAccordion", LazyNavAccordion],
["NavDivider", LazyNavDivider],
["NavGroupTitle", LazyNavGroupTitle],
["NavItem", LazyNavItem],
["NavItems", LazyNavItems],
["SideNav", LazySideNav],
["TabbedNav", LazyTabbedNav],
["OrdersTable", LazyOrdersTable],
["ProtectedOrderItemCard", LazyProtectedOrderItemCard],
["ProtectedOrderMetricRow", LazyProtectedOrderMetricRow],
["ReimbursementModal", LazyReimbursementModal],
["StatisticTile", LazyStatisticTile],
["SearchInput", LazySearchInput],
["SearchModal", LazySearchModal],
["SearchProductModal", LazySearchProductModal],
["CopyText", LazyCopyText],
["CustomerAddress", LazyCustomerAddress],
["EditButton", LazyEditButton],
["ApiTokenCard", LazyApiTokenCard],
["ApiTokenCardSkeleton", LazyApiTokenCardSkeleton],
["EmptyState", LazyEmptyState],
["DropArea", LazyDropArea],
["MediaUploader", LazyMediaUploader],
["PageIcon", LazyPageIcon],
["SharedFooter", LazySharedFooter],
["BasicModal", LazyBasicModal],
["SimplePopover", LazySimplePopover],
["SelectionGroup", LazySelectionGroup],
["ErrorGroup", LazyErrorGroup],
["StoreDisplay", LazyStoreDisplay],
["StoreSelect", LazyStoreSelect],
["StoreSelectButton", LazyStoreSelectButton],
["TeamMembersInfoButton", LazyTeamMembersInfoButton],
["UserRoleBadge", LazyUserRoleBadge],
["CreateTeamMember", LazyCreateTeamMember],
["TeamMembersEntitlementsCard", LazyTeamMembersEntitlementsCard],
["TeamMembersInfoModal", LazyTeamMembersInfoModal],
["ThemeSwitch", LazyThemeSwitch],
["NotificationToast", LazyNotificationToast],
["ToastController", LazyToastController],
["WebhookCard", LazyWebhookCard],
["WebhookCardSkeleton", LazyWebhookCardSkeleton],
["WebhookTopicGroup", LazyWebhookTopicGroup],
["PulseEmptyState", LazyPulseEmptyState],
["PulseLoadingSpinner", LazyPulseLoadingSpinner],
["PulseMediaCarousel", LazyPulseMediaCarousel],
["PulseTooltip", LazyPulseTooltip],
["PulseBanner", LazyPulseBanner],
["PulseChatAttachment", LazyPulseChatAttachment],
["PulseClaimFeed", LazyPulseClaimFeed],
["PulseCustomerAddress", LazyPulseCustomerAddress],
["PulseCustomerAddresses", LazyPulseCustomerAddresses],
["PulseDataMetric", LazyPulseDataMetric],
["PulseFeedback", LazyPulseFeedback],
["PulseFulfillmentInfo", LazyPulseFulfillmentInfo],
["PulseInfoBanner", LazyPulseInfoBanner],
["PulseMessagingEvent", LazyPulseMessagingEvent],
["PulseMessagingEventDivider", LazyPulseMessagingEventDivider],
["PulseMessagingFeed", LazyPulseMessagingFeed],
["PulseModal", LazyPulseModal],
["PulsePlatformAvatar", LazyPulsePlatformAvatar],
["PulseProductDisplay", LazyPulseProductDisplay],
["PulseReshipRefundResolutionDetails", LazyPulseReshipRefundResolutionDetails],
["PulseShippingClaimMetric", LazyPulseShippingClaimMetric],
["PulseStatusBadge", LazyPulseStatusBadge],
["PulseSuccessBanner", LazyPulseSuccessBanner],
["PulseTagList", LazyPulseTagList],
["PulseToggleDisplay", LazyPulseToggleDisplay],
["PulseTrackingInfo", LazyPulseTrackingInfo],
["PulseUserAvatar", LazyPulseUserAvatar],
["PulseWarningBanner", LazyPulseWarningBanner],
["PulseTable", LazyPulseTable],
["PulseTableGridSkeleton", LazyPulseTableGridSkeleton],
["PulseTableSkeleton", LazyPulseTableSkeleton],
["PulseAddBook", LazyPulseAddBook],
["PulseApiLogo", LazyPulseApiLogo],
["PulseArmraLogo", LazyPulseArmraLogo],
["PulseArrowsRightLeft", LazyPulseArrowsRightLeft],
["PulseBigCommerce", LazyPulseBigCommerce],
["PulseCheckCircle", LazyPulseCheckCircle],
["PulseCircleLogo", LazyPulseCircleLogo],
["PulseClaimInfoSubscribedRightArrows", LazyPulseClaimInfoSubscribedRightArrows],
["PulseClaimTodoApprovedDeniedSolidArrow", LazyPulseClaimTodoApprovedDeniedSolidArrow],
["PulseClaimTodoClosedSolidArrow", LazyPulseClaimTodoClosedSolidArrow],
["PulseClaimTodoDashed", LazyPulseClaimTodoDashed],
["PulseClaimTodoDashedArrow", LazyPulseClaimTodoDashedArrow],
["PulseClaimTodoOnholdDashed", LazyPulseClaimTodoOnholdDashed],
["PulseClaimTodoOnholdDashedArrow", LazyPulseClaimTodoOnholdDashedArrow],
["PulseClaimTodoPendingDashed", LazyPulseClaimTodoPendingDashed],
["PulseClaimTodoPendingDashedArrow", LazyPulseClaimTodoPendingDashedArrow],
["PulseClaimTodoSolidLine", LazyPulseClaimTodoSolidLine],
["PulseDatePicker", LazyPulseDatePicker],
["PulseEarthGlobeTimezone", LazyPulseEarthGlobeTimezone],
["PulseFolderCheck", LazyPulseFolderCheck],
["PulseFollowUp", LazyPulseFollowUp],
["PulseIconApprove", LazyPulseIconApprove],
["PulseIconArmra", LazyPulseIconArmra],
["PulseIconAvatar", LazyPulseIconAvatar],
["PulseIconBuilding", LazyPulseIconBuilding],
["PulseIconCheck", LazyPulseIconCheck],
["PulseIconClose", LazyPulseIconClose],
["PulseIconCreditCard", LazyPulseIconCreditCard],
["PulseIconCustom", LazyPulseIconCustom],
["PulseIconDanger", LazyPulseIconDanger],
["PulseIconDollar", LazyPulseIconDollar],
["PulseIconEdit", LazyPulseIconEdit],
["PulseIconGoogle", LazyPulseIconGoogle],
["PulseIconInfo", LazyPulseIconInfo],
["PulseIconLock", LazyPulseIconLock],
["PulseIconLogo", LazyPulseIconLogo],
["PulseIconRefund", LazyPulseIconRefund],
["PulseIconSend", LazyPulseIconSend],
["PulseIconShipment", LazyPulseIconShipment],
["PulseIconShopify", LazyPulseIconShopify],
["PulseIconWarning", LazyPulseIconWarning],
["PulseImageCancel", LazyPulseImageCancel],
["PulseLineAlign", LazyPulseLineAlign],
["PulseLineAlphabet", LazyPulseLineAlphabet],
["PulseLineAngleDoubleLeft", LazyPulseLineAngleDoubleLeft],
["PulseLineAngleDoubleRight", LazyPulseLineAngleDoubleRight],
["PulseLineAngleDown", LazyPulseLineAngleDown],
["PulseLineAngleLeft", LazyPulseLineAngleLeft],
["PulseLineAngleRight", LazyPulseLineAngleRight],
["PulseLineAngleUp", LazyPulseLineAngleUp],
["PulseLineAppleAlt", LazyPulseLineAppleAlt],
["PulseLineArchive", LazyPulseLineArchive],
["PulseLineArrow", LazyPulseLineArrow],
["PulseLineArrowDownRight", LazyPulseLineArrowDownRight],
["PulseLineArrowLeft", LazyPulseLineArrowLeft],
["PulseLineArrowRight", LazyPulseLineArrowRight],
["PulseLineBars", LazyPulseLineBars],
["PulseLineBold", LazyPulseLineBold],
["PulseLineBolt", LazyPulseLineBolt],
["PulseLineBookMedical", LazyPulseLineBookMedical],
["PulseLineBox", LazyPulseLineBox],
["PulseLineBuilding", LazyPulseLineBuilding],
["PulseLineCameraPlus", LazyPulseLineCameraPlus],
["PulseLineCameraQuestion", LazyPulseLineCameraQuestion],
["PulseLineChart", LazyPulseLineChart],
["PulseLineChatBubbleUser", LazyPulseLineChatBubbleUser],
["PulseLineCheckCircle", LazyPulseLineCheckCircle],
["PulseLineClipboardAlt", LazyPulseLineClipboardAlt],
["PulseLineCodeBranch", LazyPulseLineCodeBranch],
["PulseLineCoins", LazyPulseLineCoins],
["PulseLineCommentAlt", LazyPulseLineCommentAlt],
["PulseLineCommentAltBlock", LazyPulseLineCommentAltBlock],
["PulseLineCommentDots", LazyPulseLineCommentDots],
["PulseLineCommentMessage", LazyPulseLineCommentMessage],
["PulseLineCommentQuestion", LazyPulseLineCommentQuestion],
["PulseLineComparison", LazyPulseLineComparison],
["PulseLineCopy", LazyPulseLineCopy],
["PulseLineCornerUpLeftAlt", LazyPulseLineCornerUpLeftAlt],
["PulseLineCornerUpRightAlt", LazyPulseLineCornerUpRightAlt],
["PulseLineCreditCard", LazyPulseLineCreditCard],
["PulseLineDashboard", LazyPulseLineDashboard],
["PulseLineDownloadAlt", LazyPulseLineDownloadAlt],
["PulseLineDraggabledots", LazyPulseLineDraggabledots],
["PulseLineEllipsisH", LazyPulseLineEllipsisH],
["PulseLineExclamationCircle", LazyPulseLineExclamationCircle],
["PulseLineExclamationOctagon", LazyPulseLineExclamationOctagon],
["PulseLineExport", LazyPulseLineExport],
["PulseLineExternalLinkAlt", LazyPulseLineExternalLinkAlt],
["PulseLineEye", LazyPulseLineEye],
["PulseLineEyeSlash", LazyPulseLineEyeSlash],
["PulseLineFileCopyAlt", LazyPulseLineFileCopyAlt],
["PulseLineFileLandscape", LazyPulseLineFileLandscape],
["PulseLineFilter", LazyPulseLineFilter],
["PulseLineFire", LazyPulseLineFire],
["PulseLineFolder", LazyPulseLineFolder],
["PulseLineFolderOpen", LazyPulseLineFolderOpen],
["PulseLineFont", LazyPulseLineFont],
["PulseLineGithubAlt", LazyPulseLineGithubAlt],
["PulseLineGlobe", LazyPulseLineGlobe],
["PulseLineImage", LazyPulseLineImage],
["PulseLineImageBroken", LazyPulseLineImageBroken],
["PulseLineImport", LazyPulseLineImport],
["PulseLineInfoCircle", LazyPulseLineInfoCircle],
["PulseLineItalic", LazyPulseLineItalic],
["PulseLineLeftIndent", LazyPulseLineLeftIndent],
["PulseLineLinkAlt", LazyPulseLineLinkAlt],
["PulseLineListOl", LazyPulseLineListOl],
["PulseLineListUl", LazyPulseLineListUl],
["PulseLineLock", LazyPulseLineLock],
["PulseLineMessage", LazyPulseLineMessage],
["PulseLineMinusCircle", LazyPulseLineMinusCircle],
["PulseLineMoney", LazyPulseLineMoney],
["PulseLineMoneyWithdraw", LazyPulseLineMoneyWithdraw],
["PulseLineMoon", LazyPulseLineMoon],
["PulseLinePalette", LazyPulseLinePalette],
["PulseLinePaperclip", LazyPulseLinePaperclip],
["PulseLinePen", LazyPulseLinePen],
["PulseLinePhone", LazyPulseLinePhone],
["PulseLinePlus", LazyPulseLinePlus],
["PulseLinePlusCircle", LazyPulseLinePlusCircle],
["PulseLinePlusSquare", LazyPulseLinePlusSquare],
["PulseLineRefresh", LazyPulseLineRefresh],
["PulseLineRightIndentAlt", LazyPulseLineRightIndentAlt],
["PulseLineRocket", LazyPulseLineRocket],
["PulseLineSearch", LazyPulseLineSearch],
["PulseLineSetting", LazyPulseLineSetting],
["PulseLineShield", LazyPulseLineShield],
["PulseLineSlack", LazyPulseLineSlack],
["PulseLineSort", LazyPulseLineSort],
["PulseLineStar", LazyPulseLineStar],
["PulseLineSun", LazyPulseLineSun],
["PulseLineSwatchbook", LazyPulseLineSwatchbook],
["PulseLineSync", LazyPulseLineSync],
["PulseLineTable", LazyPulseLineTable],
["PulseLineTag", LazyPulseLineTag],
["PulseLineTimes", LazyPulseLineTimes],
["PulseLineTimesCircle", LazyPulseLineTimesCircle],
["PulseLineToggleOff", LazyPulseLineToggleOff],
["PulseLineToggleOn", LazyPulseLineToggleOn],
["PulseLineTransaction", LazyPulseLineTransaction],
["PulseLineTrashAlt", LazyPulseLineTrashAlt],
["PulseLineUnderline", LazyPulseLineUnderline],
["PulseLineUsdCircle", LazyPulseLineUsdCircle],
["PulseLineUsersAlt", LazyPulseLineUsersAlt],
["PulseLoopreturns", LazyPulseLoopreturns],
["PulseMagentoLogo", LazyPulseMagentoLogo],
["PulseNoResponse", LazyPulseNoResponse],
["PulseOutsideOp", LazyPulseOutsideOp],
["PulsePackage", LazyPulsePackage],
["PulsePackageArrived", LazyPulsePackageArrived],
["PulsePlayCircle", LazyPulsePlayCircle],
["PulsePlusCircle", LazyPulsePlusCircle],
["PulseQueueList", LazyPulseQueueList],
["PulseRefreshResentMail", LazyPulseRefreshResentMail],
["PulseShieldCheck", LazyPulseShieldCheck],
["PulseShipstation", LazyPulseShipstation],
["PulseShopifyAvatar", LazyPulseShopifyAvatar],
["PulseShopifyBag", LazyPulseShopifyBag],
["PulseSolidStar", LazyPulseSolidStar],
["PulseTableDeleteColumn", LazyPulseTableDeleteColumn],
["PulseTableDeleteRow", LazyPulseTableDeleteRow],
["PulseTableInsertColumnAfter", LazyPulseTableInsertColumnAfter],
["PulseTableInsertColumnBefore", LazyPulseTableInsertColumnBefore],
["PulseTableInsertRowAbove", LazyPulseTableInsertRowAbove],
["PulseTableInsertRowAfter", LazyPulseTableInsertRowAfter],
["PulseTableOptions", LazyPulseTableOptions],
["PulseTableSettings", LazyPulseTableSettings],
["PulseTipaltiLogo", LazyPulseTipaltiLogo],
["PulseXCircle", LazyPulseXCircle],
["PulseXMark", LazyPulseXMark],
["PulseAccordionCard", LazyPulseAccordionCard],
["PulseBasicCard", LazyPulseBasicCard],
["PulsePageIcon", LazyPulsePageIcon],
["PulseShippingClaim", LazyPulseShippingClaim],
["PulseSingleClaim", LazyPulseSingleClaim],
["PulseTabbedNav", LazyPulseTabbedNav],
["PulseButton", LazyPulseButton],
["PulseChatImageUploader", LazyPulseChatImageUploader],
["PulseColorInput", LazyPulseColorInput],
["PulseDateRangePicker", LazyPulseDateRangePicker],
["PulseDropdown", LazyPulseDropdown],
["PulseIconButton", LazyPulseIconButton],
["PulseInput", LazyPulseInput],
["PulseLabelPopper", LazyPulseLabelPopper],
["PulseMessageBox", LazyPulseMessageBox],
["PulseMultiDropdown", LazyPulseMultiDropdown],
["PulseMultiSelectDropdown", LazyPulseMultiSelectDropdown],
["PulseOptionsMenu", LazyPulseOptionsMenu],
["PulsePasswordInput", LazyPulsePasswordInput],
["PulseRadioButton", LazyPulseRadioButton],
["PulseRadioQuestion", LazyPulseRadioQuestion],
["PulseRteFileComponent", LazyPulseRteFileComponent],
["PulseRteVideoComponent", LazyPulseRteVideoComponent],
["PulseRichTextEditor", LazyPulseRichTextEditor],
["PulseSelect", LazyPulseSelect],
["PulseTagSelect", LazyPulseTagSelect],
["PulseTextArea", LazyPulseTextArea],
["PulseToggle", LazyPulseToggle],
["PulseValidationGroup", LazyPulseValidationGroup],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
